export enum OptoutTypeEnum {

    MANUAL = 'MANUAL',
    REPLY_AUTOMATIC = 'REPLY_AUTOMATIC',
    LOOKUP_AUTOMATIC = 'LOOKUP_AUTOMATIC',
    CALLBACK_AUTOMATIC = 'CALLBACK_AUTOMATIC'

}